import { AvailabilitySlot } from "./generateStartTimes";

export const compressToUnqiueTimeslots = (availabilites: AvailabilitySlot[]) => {
  const uniqueTimeslots: { [key: string]: AvailabilitySlot[] } = {};
  availabilites.forEach((obj) => {
    const objStartTime = obj.startTime;
    if (objStartTime in uniqueTimeslots) {
      uniqueTimeslots[objStartTime].push(obj);
    } else {
      uniqueTimeslots[objStartTime] = [obj];
    }
  });

  return uniqueTimeslots;
};
